import React from 'react';
import { Link } from 'react-router-dom';
import BackgroundImage from '../../../../components/BackgroundImage';
import { getDefaultAvatar } from '../../../../utils/collegeCorner';

import { POWER6_KEYS } from '../../../../utils/constants';
import { defaultConferenceColumn, defaultDivisionColumn, defaultGenderColumn, defaultP6Column, defaultRankingColumn, defaultTableFilters, SORT_ORDER } from '../helpers';
import styles from './CollegeCornerCollegeTeams.scss';

export const getInitialTableFilters = (isRostersRolloutEnabled = false) => ({
    ...defaultTableFilters,
    sort: isRostersRolloutEnabled ? POWER6_KEYS.ACTIVE_ROSTER : POWER6_KEYS.SCHOOL,
});

export const getInitialFilters = (isRostersRolloutEnabled = false) => ({
    ...getInitialTableFilters(isRostersRolloutEnabled),
    gender: null,
    conference: null,
    division: null,
    locationInputValue: '',
    locationCountryName: '',
    locationStateName: '',
    distance: '50mi',
    location: '',
    lat: null,
    lng: null,
});

const getPower6ValueFromActiveRoster = (item) => {
    return item?.source?.activeRoster?.power6?.power6Rating ?? null;
};

const getPower6ValueFromSchool = (item) => {
    return item?.source?.school?.power6 ?? null;
};

const formatPower6Value = (value, isMasked = false) => {
    if (!value || typeof value !== 'number') {
        return '0';
    }
    return isMasked ? `${value.toFixed(0)}.xx` : value.toFixed(2);
};

export const getColumns = (isRostersRolloutEnabled = false) => {
    const power6Key = isRostersRolloutEnabled ? POWER6_KEYS.ACTIVE_ROSTER : POWER6_KEYS.SCHOOL;
    const power6MaskedKey = isRostersRolloutEnabled ? POWER6_KEYS.ACTIVE_ROSTER_MASKED : POWER6_KEYS.SCHOOL_MASKED;

    const getPower6Value = isRostersRolloutEnabled
        ? getPower6ValueFromActiveRoster
        : getPower6ValueFromSchool;

    return [
        {
            ...defaultRankingColumn,
            maxWidth: 5,
            sortable: false,
            headerClassName: `${styles.rankingHead}`,
            rowClassName: `${styles.rankingCol}`,
            custom: (val, item, { rowIndex, total, order }) => {
                return order === SORT_ORDER.DESC ? rowIndex + 1 : total - rowIndex;
            },
        },
        {
            title: 'College',
            sortable: false,
            key: 'name',
            maxWidth: 25,
            rowClassName: `${styles.nameCol}`,
            custom: (val, item) => {
                const collegeName = item?.source?.name || '';
                return (
                    <div className={`${styles.CollegeName}`}>
                        <div className={`${styles.displayLogo}`}>
                            {item.source.clubProfileImages && (
                                <BackgroundImage
                                    baseUrl={'/v1/club/'}
                                    defaultImage={getDefaultAvatar(item.source)}
                                    images={item.source.clubProfileImages}
                                    imageType={'icon'}
                                    parentStylesClass={styles.profilePicture}
                                />
                            )}
                        </div>
                        <Link className="link" to={`/colleges/${item.id}`}>{collegeName}</Link>
                    </div>
                );
            },
        },
        {
            ...defaultGenderColumn,
            headerClassName: `${styles.genderHead}`,
            rowClassName: `${styles.genderCol}`,
            custom: (val, item) => item?.source?.gender || '',
        },
        {
            ...defaultP6Column,
            headerClassName: `${styles.psixHead}`,
            key: power6Key,
            rowClassName: `${styles.psixCol}`,
            custom: (val, item) => {
                const power6 = getPower6Value(item);
                return formatPower6Value(power6, false);
            },
        },
        {
            ...defaultP6Column,
            key: power6MaskedKey,
            sortable: false,
            headerClassName: `${styles.psixHead}`,
            rowClassName: `${styles.psixCol}`,
            custom: (val, item) => {
                const power6 = getPower6Value(item);
                return formatPower6Value(power6, true);
            },
        },
        {
            title: 'Location',
            maxWidth: 13,
            sortable: false,
            headerClassName: `${styles.locationHead}`,
            rowClassName: `${styles.locationCol}`,
            custom: (val, item) => item?.source?.location?.display || '',
        },
        {
            ...defaultDivisionColumn,
            headerClassName: `${styles.divisionHead}`,
            rowClassName: `${styles.divisionCol}`,
            custom: (val, item) => item?.source?.school?.conference?.division?.divisionName || '',
        },
        {
            ...defaultConferenceColumn,
            headerClassName: `${styles.conferenceHead}`,
            rowClassName: `${styles.conferenceCol}`,
            custom: (val, item) => item?.source?.school?.conference?.conferenceName || '',
        },
    ];
};
